export const messages = {
    en: {
      adminInspectionTaskDetail: {
        title: 'Inspection Task',
        taskId: 'Task Code',
        inspectionPlanName: 'Inspection Plan',
        planTime: 'Start/End Time',
        actInsTime: 'Actual Inspection Time',
        originalPlanUser: 'Planned Inspector',
        currentPlanUser: 'Current Inspector',
        transferDesc: 'Transfer Description',
        signType: 'Inspection Method',
        state: 'Inspection Status',
        tab: {
          detail: 'Inspection Details',
          map: 'Inspection Map',
          plan: 'Inspection Plan',
          route: 'Inspection Route',
          point: 'Inspection Points'
        }
      },
      adminRoutePlan: {
        table: {
          planName: 'Plan Name',
          routeName: 'Route Name',
          planPeriod: 'Plan Period',
          signType: 'Sign Type',
          dateRange: 'Date Range',
          timeRange: 'Time Range',
          beforeTime: 'Before Time (minutes)',
          creator: 'Creator',
          createTime: 'Create Time',
          inspectors: 'Inspectors',
          status: 'Status'
        }
      }
    },
    zh: {
      adminInspectionTaskDetail: {
        title: '巡检任务',
        taskId: '任务编码',
        inspectionPlanName: '巡检计划',
        planTime: '开始/结束时间',
        actInsTime: '实际巡检时间',
        originalPlanUser: '计划巡检人',
        currentPlanUser: '当前巡检人',
        transferDesc: '转移描述',
        signType: '巡检方式',
        state: '巡检状态',
        tab: {
          detail: '巡检明细',
          map: '巡检地图',
          plan: '巡检计划',
          route: '巡检路线',
          point: '巡检点'
        }
      },
      adminRoutePlan: {
        table: {
          planName: '计划名称',
          routeName: '计划路线',
          planPeriod: '计划周期',
          signType: '签到方式',
          dateRange: '日期范围',
          timeRange: '时间范围',
          beforeTime: '任务提前(分钟)',
          creator: '制定人',
          createTime: '制定时间',
          inspectors: '巡检人',
status: '状态'
        }
      }
    },
    'zh-TW': {
      adminInspectionTaskDetail: {
        title: '巡檢任務',
        taskId: '任務編碼',
        inspectionPlanName: '巡檢計劃',
        planTime: '開始/結束時間',
        actInsTime: '實際巡檢時間',
        originalPlanUser: '計劃巡檢人',
        currentPlanUser: '當前巡檢人',
        transferDesc: '轉移描述',
        signType: '巡檢方式',
        state: '巡檢狀態',
        tab: {
          detail: '巡檢明細',
          map: '巡檢地圖',
          plan: '巡檢計劃',
          route: '巡檢路線',
          point: '巡檢點'
        }
      },
      adminRoutePlan: {
        table: {
          planName: '計劃名稱',
          routeName: '計劃路線',
          planPeriod: '計劃週期',
          signType: '簽到方式',
          dateRange: '日期範圍',
          timeRange: '時間範圍',
          beforeTime: '任務提前(分鐘)',
          creator: '制定人',
          createTime: '制定時間',
          inspectors: '巡檢人',
          status: '狀態'
        }
      }
    }
  }